import React from 'react';
import cx from 'classnames';
import { getWarehouseClass } from '../../utils/getWarehouseClass';

import { Button } from '../Button/Button';

export const OrderListItem = ({selected, order, hideStatus, onClick, onFocusClick, onAddDriverBreakTime, showOrderColor, calculatedArrivalTime, routeId }) => {
  const {
    trackingId,
    senderOrderId,
    deliveryPostcode,
    deliveryCity,
    deliveryStreet,
    deliveryHouse,
    deliveryFirstName,
    deliveryLastName,
    sender: {
      maxWarehouseDays,
    } = {},
    onWarehouseFrom,
    pickupAt,
    buffer,
  } = order;

  const color = '#5A8DEE';
  const status = order?.deliveryConfirmations?.filter((confirmation) => confirmation.routeId === routeId)?.[0]?.status;
  const getBackgroundClass = (status, showOrderColor) => {
    if (!showOrderColor) return null;

    if (status === 'confirmed') {
      return 'bg-success text-white';
    }
    if (status === 'pending') {
      return 'bg-warning text-white';
    }
    if (status?.toLowerCase().includes('cancel')) {
      return 'bg-danger text-white';
    }

    return null;
  };

  const backgroundClass = getBackgroundClass(status, showOrderColor);

  const wrapperClass = cx(
    'order-map__item',
    backgroundClass,
    getWarehouseClass(
      onWarehouseFrom,
      maxWarehouseDays,
      'order-map__item',
      pickupAt ? new Date(pickupAt) : new Date(),
    ),
    {
      'order-map__item--added': selected,
    },
  );

  return (
    <>
      {buffer && (
        <div className="order-map__item bg-warning text-white">
          <p className="text-bold-700 tx-08 mb-0 lh-1">{__('routes.time_buffer')}:</p>
          <p className="text-bold-700 tx-08 mb-0 lh-1">{buffer}</p>
        </div>
      )}

        <div className={wrapperClass} onClick={!hideStatus ? onClick : () => null}>
          <div className="row mb--5px">
            <div className="col-md-6">
              <p className="text-bold-700 tx-08 mb-0 lh-1">
                {deliveryPostcode} {deliveryStreet} {deliveryHouse}, {deliveryCity}
              </p>
              <p className="tx-08 mb-3px lh-1">
                {deliveryFirstName} {deliveryLastName}
              </p>
            </div>
            <div className="col-md-6">
              <p className="text-bold-700 tx-08 mb-0 lh-1">
                <a href={`/admin/orders/show/${order.id}`} target="_blank">
                  {trackingId}
                </a>
              </p>
              <p className="text-muted tx-08 mb-0 lh-1">{senderOrderId}</p>

              <p className="tx-08 lh-1">
                {calculatedArrivalTime}
              </p>

              {hideStatus && (
                <>
                  <Button onClick={onClick} className="btn-xs btn-outline-danger mr-5px order-map__button hidden"
                          icon="bx bx-x" />
                  <Button onClick={onFocusClick} className="btn-xs btn-outline-primary order-map__button hidden"
                          icon="bx bx-search" />
                </>
              )}
            </div>
          </div>




          {color && !hideStatus && (
            <div className="orders_list_statuses" style={{ background: color }} />
          )}

          <div className="order-map__counter" style={{ background: color }} />
        </div>
    </>
  );
};
